import { useState } from 'react';

const useShowPassword = ({ typePassword, typePasswordConfirm }) => {
  const [showPassword, setShowPassword] = useState({
    password: false,
    password_confirm: false,
  });

  const onShowPassword = (type, show) => {
    if (type === typePassword) {
      if (show) setShowPassword({ ...showPassword, password: false });
      else if (!show) setShowPassword({ ...showPassword, password: true });
    } else if (type === typePasswordConfirm) {
      if (show) setShowPassword({ ...showPassword, password_confirm: false });
      else if (!show) setShowPassword({ ...showPassword, password_confirm: true });
    }
  };

  return {
    showPassword,
    onShowPassword,
  };
};

export default useShowPassword;
